import { getAPIFullUrl, getAxiosConfig, handleApiError, risapi } from '../risapi'; // Adjust path as needed

/**
 * Fetches a list of all franchisees.
 */
export const getFranchisees = async (filterParameters, callback) => {
    try {
        // Uses the new /milma-admin/ prefix
        const response = await risapi.get(getAPIFullUrl('/api/milma-admin/franchisees', filterParameters), getAxiosConfig());
        if (response.status >= 200 && response.status < 300) {
             callback(response.data); // Contains { franchisees: [...] }
        } else {
             callback({ error: { message: `Unexpected status: ${response.status}` } });
        }
    } catch (error) {
        console.error("API Error in getFranchisees:", error);
        handleApiError(error); 
        callback({ error }); 
    }
};

/**
 * Creates a new franchisee. 
 * NOTE: newData should be a FormData object when uploading files.
 */
export const createFranchisee = async (newData, callback) => {
    try {
        // Prepare headers: If it's FormData, let Axios set the boundary automatically
        // by NOT setting Content-Type manually, or setting it to multipart/form-data.
        const config = getAxiosConfig();
        
        // If it's FormData, Axios handles the boundary automatically
        const response = await risapi.post('/api/milma-admin/franchisees', newData, {
            ...config,
            headers: {
                ...config.headers,
                'Content-Type': 'multipart/form-data',
            }
        });

        if (response.status === 201) {
            callback(response.data);
        } else {
             callback({ error: { response } });
        }
    } catch (error) {
        console.error("API Error in createFranchisee:", error);
        callback({ error });
    }
};


export const destroyFranchisee = async (id, callback) => {
    try {
        const response = await risapi.delete(`/api/milma-admin/franchisees/${id}`, getAxiosConfig());
        if (response.status === 204) {
            callback(response);
        }
    } catch (error) {
        callback({ error });
    }
};

export const getFranchiseeUsers = async (franchiseeId, callback) => {
    try {
        const response = await risapi.get(`/api/milma-admin/franchisees/${franchiseeId}/users`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        callback({ error });
    }
};
// ... (fetchFranchisee, updateFranchisee, destroyFranchisee can be added later) ...

